import React from 'react';

import { cn } from '@sandtech-hub-monorepo/ui-kit';

interface Props {
  icon: React.ReactNode;
  label: string;
  value?: string | null;
  /**
   * Replaces the default single-line truncation. The user ID needs it: a
   * truncated identifier is no use to the learner reading it out to support.
   */
  valueClassName?: string;
  /** A trailing action for this row alone, e.g. copy-to-clipboard for the User ID. */
  action?: React.ReactNode;
}

/**
 * One labelled field in the Personal Information card. Read-only: every
 * field is edited together via the card header's single pencil, not per row.
 */
export const PersonalInfoRow = ({
  icon,
  label,
  value,
  valueClassName = 'truncate',
  action,
}: Props) => (
  <div className="flex items-center gap-3">
    <div className="flex items-center justify-center size-[38px] shrink-0 rounded-[14px] border border-primary text-primary">
      {icon}
    </div>
    <div className="flex flex-col flex-1 min-w-0">
      <span className="text-xs text-muted-foreground">{label}</span>
      <span className={cn('text-sm text-foreground', valueClassName)}>
        {value || '—'}
      </span>
    </div>
    {action}
  </div>
);
